<ng-template>
  <section #popupComponent>
    <div class="triangle-up"></div>
    <section class="popup-container">
      <ng-container *ngIf="isLoading; else loadedChainData">
        Loading
      </ng-container>
      <ng-template #loadedChainData>
        <h2>
          <i class="material-icons notranslate">playlist_play</i>
          Chained rule group
        </h2>
        <h3 class="heading-underline sub-title">
          Part of group: <span class="green">{{chainData.name}}</span>
        </h3>
        <section>
          <ul id="chained-rules">
            <li
              *ngFor="let rule of chainData.rules; let i = index"
              [ngClass]="{
              'shaded': !isRuleMatch(rule.id)
              }"
            >
              <div class="selected-entity rule-title">
                <i [matTooltip]="rule.entity" [className]="renderIcon(rule.entity)"></i>
                <ng-container *ngIf="utilsService.compareInternalDataRuleIds(ruleId, chainData.rules[i].id); else shadedRule">
                  <div>{{rule.name}}</div>
                </ng-container>
                <ng-template #shadedRule>
                  <div
                    class="link"
                    [matTooltip]="'Navigate to rule ' + chainData.rules[i].name"
                    (click)="collapseAndNavigateToDataRules(rule.entity, [rule.id])">
                    {{rule.name}}
                  </div>
                </ng-template>
              </div>
            </li>
          </ul>
        </section>
      </ng-template>
    </section>
  </section>

</ng-template>
